export enum ApplicantsType {
  HIRED = 'HIRED',
  APPLIED = 'APPLIED',
  DATABASE = 'DATABASE',
  HIDDEN = 'HIDDEN',
  OFFERED = 'OFFERED',
}
